import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { TranslatePipe } from '@ngx-translate/core';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { HeaderComponent } from '../header/header.component';
import { BottomNavComponent } from '../bottom-nav/bottom-nav.component';
import { LayoutService } from '../../core/services/layout.service';
import { StoreContextService } from '../../core/services/store-context.service';
import { AuthService } from '../../core/services/auth.service';
import { BillingService } from '../../core/services/billing.service';

const SYSTEM_STAFF_ROLES = ['SuperAdmin', 'Admin', 'Operator'];

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ToastModule,
    SidebarComponent,
    HeaderComponent,
    BottomNavComponent,
    TranslatePipe,
  ],
  templateUrl: './shell.component.html',
})
export class ShellComponent implements OnInit {
  private layoutService = inject(LayoutService);
  private storeContext = inject(StoreContextService);
  private auth = inject(AuthService);
  private billingService = inject(BillingService);
  private readonly destroyRef = inject(DestroyRef);

  isSidebarCollapsed = this.layoutService.isSidebarCollapsed;
  subscriptionDaysLeft: number | null = null;

  ngOnInit(): void {
    const role = this.auth.user()?.role ?? '';
    if (!SYSTEM_STAFF_ROLES.includes(role)) {
      this.storeContext.loadStores();
      this.loadSubscriptionWarning();
    }
  }

  private loadSubscriptionWarning(): void {
    this.billingService
      .getMyBilling()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          if (res.success && res.data) {
            this.billingService.includedModules.set(res.data.includedModules ?? []);
          }

          const endDate = res.success ? res.data.subscriptionEndDate : null;
          if (!endDate || !res.data.isActive) {
            this.subscriptionDaysLeft = null;
            return;
          }

          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const end = new Date(endDate);
          end.setHours(0, 0, 0, 0);
          const daysLeft = Math.ceil((end.getTime() - today.getTime()) / 86400000);
          this.subscriptionDaysLeft = daysLeft >= 0 && daysLeft <= 5 ? daysLeft : null;
        },
        error: () => {
          this.subscriptionDaysLeft = null;
        },
      });
  }
}
